import { trackError } from './errorTracking'

const RELOAD_FLAG_KEY = 'sellerlandingui.chunkReload'

const isChunkLoadError = (error) =>
  error?.name === 'ChunkLoadError' ||
  /loading chunk .* failed/i.test(error?.message || '') ||
  /failed to fetch dynamically imported module/i.test(error?.message || '')

const reloadOnceForStaleChunk = (reload, storage) => {
  try {
    if (storage.getItem(RELOAD_FLAG_KEY)) {
      // Already tried a reload for this session; avoid infinite reload loop.
      return false
    }
    storage.setItem(RELOAD_FLAG_KEY, '1')
    reload()
    return true
  } catch {
    return false
  }
}

const handleError = (error, type, reload, storage) => {
  if (isChunkLoadError(error) && reloadOnceForStaleChunk(reload, storage)) {
    return
  }
  trackError(error, { type })
}

/**
 * Registers global handlers so uncaught errors and unhandled promise
 * rejections are funneled into trackError(). Call once at app bootstrap.
 */
export const registerChunkErrorHandlers = ({
  reload = () => window.location.reload(),
  storage = window.sessionStorage,
} = {}) => {
  window.addEventListener('error', (event) => {
    handleError(
      event.error || new Error(event.message),
      'uncaught',
      reload,
      storage,
    )
  })

  window.addEventListener('unhandledrejection', (event) => {
    const reason =
      event.reason instanceof Error
        ? event.reason
        : new Error(String(event.reason))
    handleError(reason, 'unhandled_promise', reload, storage)
  })
}

export default registerChunkErrorHandlers
